import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { UnauthorizedComponent } from './unauthorized.component';


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    RouterModule
  ],
  declarations: [
    UnauthorizedComponent
  ],
  exports: [
    UnauthorizedComponent
  ],
})
export class UnauthorizedModule { }
